import { render, staticRenderFns } from "./PublishersList.vue?vue&type=template&id=0274bbcd&scoped=true&"
import script from "./PublishersList.vue?vue&type=script&lang=ts&"
export * from "./PublishersList.vue?vue&type=script&lang=ts&"
import style0 from "./PublishersList.vue?vue&type=style&index=0&id=0274bbcd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0274bbcd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0274bbcd', component.options)
    } else {
      api.reload('0274bbcd', component.options)
    }
    module.hot.accept("./PublishersList.vue?vue&type=template&id=0274bbcd&scoped=true&", function () {
      api.rerender('0274bbcd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/landing/PublishersList.vue"
export default component.exports